import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportingFeatureComponent } from './features/reporting-feature.component';
import { ReportingComponent } from './presenters/reporting.component';
import { EfaactMaterialModule } from '../efaact-material/efaact-material.module';
import { EffectsModule } from '@ngrx/effects';
import * as fromReports from './store';
import { StoreModule } from '@ngrx/store';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';



@NgModule({
  declarations: [
    ReportingFeatureComponent,
    ReportingComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    EfaactMaterialModule,
    SharedModule,
    StoreModule.forFeature(
      fromReports.reportsFeatureKey,
      fromReports.reducer
  ),
    EffectsModule.forFeature([fromReports.ReportEffects])
  ],
  exports: [
    ReportingFeatureComponent,
    ReportingComponent
  ]
})
export class ReportingModule { }

